import {Avatar, Box, Divider, Flex, Heading, HStack, Text, useDisclosure, VStack} from "@chakra-ui/react";
import React, {useState} from "react";
import {ReactComponent as Home} from "../../../assets/icons/profile/home_icon.svg";
import {ReactComponent as Wallet} from "../../../assets/icons/profile/wallet.svg";
import {ReactComponent as Time} from "../../../assets/icons/profile/time-past.svg";
import {ReactComponent as ArrowUp} from "../../../assets/icons/arrow-up.svg";
import {ReactComponent as ArrowDown} from "../../../assets/icons/arrow-down.svg";
import {ReactComponent as User} from "../../../assets/icons/profile/user-viewfinder.svg";
import {ReactComponent as Message} from "../../../assets/icons/profile/envelope.svg";
import {ReactComponent as Notification} from "../../../assets/icons/bell-notification.svg";
import {ReactComponent as Blogger} from "../../../assets/icons/profile/blogger.svg";
import {ReactComponent as UserShield} from "../../../assets/icons/profile/shield-user.svg";
import {ReactComponent as LogOut} from "../../../assets/icons/profile/log-out.svg";
import {ReactComponent as RightArrow} from "../../../assets/icons/profile/angle-right_neutral.svg";
import {ReactComponent as ArrowwUp} from "../../../assets/icons/arrowUp.svg";
import {ReactComponent as LeftArrow} from "../../../assets/icons/profile/angle-left_neutral.svg";
import {ReactComponent as Screener} from "../../../assets/icons/screener.svg";
import {ReactComponent as Hand} from "../../../assets/icons/profile/waving_hand.svg";
import {StyledButton} from "../../../components";
import styles from "./styles";

export const ProfileDrawer = ({user, setActiveTab, activeTab}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isDown, setIsDown] = useState(false);
    const onChange = () => {
        setActiveTab('web')
        setIsDown(!isDown)
    }
    return (
        <Flex
            direction={'column'}
            justifyContent={'space-between'}
            borderRadius={isExpanded ? '16px' : '24px'}
            transition="width 0.3s"
            p={'16px 16px 48px 16px'}
            position={'relative'}
            // maxH={'952px'}
            w={isExpanded ? "244px" : "96px"}
            minW={isExpanded ? "244px" : "96px"}
            bg={'neutral.1100'}>
            <Flex
                alignItems={'center'}
                justifyContent={'center'}
                w={'16px'}
                borderRight={'none'}
                borderLeftRadius={'6px'}
                bg={'neutral.800'}
                right={'0'}
                h={'40px'}
                top={'26px'}
                onClick={() => setIsExpanded(!isExpanded)}
                cursor={'pointer'}
                position={'absolute'}>
                {isExpanded ? <LeftArrow/> : <RightArrow/>}
            </Flex>
            <Box>
                <VStack
                    alignItems={isExpanded ? 'start' : 'center'}
                    gap={'12px'}>
                    <HStack>
                        <Avatar
                            border={'2px solid #23262F'}
                            w={'56px'}
                            h={'56px'}
                            cursor={'pointer'}
                            name='Dan Abrahmov'
                            src='https://bit.ly/dan-abramov'/>
                        {isExpanded && (
                            <VStack
                                alignItems={'start'}
                                gap={0}>
                                <HStack gap={0}>
                                    <Text fontSize={'body.xs'} color={'neutral.500'}>Hey</Text>
                                    <Hand/>
                                </HStack>
                                <Heading fontSize={'body.sm'} color={'neutral.400'}>{user.firstName}</Heading>
                            </VStack>
                        )}
                    </HStack>
                    <Divider borderColor={'neutral.800'}/>
                </VStack>
                <VStack
                    mt={'40px'}
                    w={isExpanded ? 'full' : ''}
                    pl={isExpanded ? '16px' : '0'}
                    alignItems={isExpanded ? 'start' : 'center'}
                    css={styles.drawerItems}
                    color={'neutral.500'}>
                    <HStack
                        onClick={() => setActiveTab('referral')}
                        className={activeTab === 'referral' && 'active-tab'}>
                        <Home/>
                        {isExpanded && <Text>Referral</Text>}
                        <Box
                            display={'none'}
                            position={'absolute'}
                            w={'100px'}
                            h={'100px'}
                            left={'-50'}
                            top={'-50'}
                            bg={'radial-gradient(50% 50% at 50% 50%, rgba(71, 121, 246, 0.35) 0%, rgba(0, 2, 140, 0) 100%)'}/>
                    </HStack>
                    <HStack
                        onClick={() => setActiveTab('wallet')}
                        className={activeTab === 'wallet' && 'active-tab'}>
                        <Wallet/>
                        {isExpanded && <Text>Payments</Text>}
                    </HStack>
                    <HStack
                        display={'flex'}
                        flexDirection={'column'}
                        alignItems={'flex-start'}
                        h={isDown ? 'max-content!important' : '56px!important'}
                        className={activeTab === 'web'}>
                        <Box
                            display={'flex'}
                            alignItems={'center'}
                            gap={'0.5rem'}
                            onClick={() => onChange()}
                        >
                            <Screener/>
                            {isExpanded && <Text>Screener</Text>}
                            {isDown ? <ArrowUp/> : <ArrowDown/>}
                        </Box>
                        <Box
                            overflow={'hidden'}
                            transition={'all 0.3s ease'}
                            opacity={isDown ? 1 : 0}
                            h={isDown ? 'max-content!important' : '0!important'} // adjust maxHeight accordingly
                        >
                            <HStack
                                p={'16px 32px'}
                                onClick={() => setActiveTab('web')}
                                className={activeTab === 'web' && 'active-tab'}>
                                {isExpanded && <Text>Web version</Text>}
                            </HStack>
                            <HStack
                                p={'16px 32px'}
                                onClick={() => setActiveTab('templates')}
                                className={activeTab === 'templates' && 'active-tab' || activeTab === 'addTemplate' && 'active-tab'}>
                                {isExpanded && <Text>Templates</Text>}
                            </HStack>
                            <HStack
                                p={'16px 32px'}
                                onClick={() => setActiveTab('screeners')}
                                className={(activeTab === 'screeners'||activeTab === 'addScreeners') && 'active-tab'}>
                                {isExpanded && <Text>Screeners</Text>}
                            </HStack>
                            <HStack
                                p={'16px 32px'}
                                onClick={() => setActiveTab('notifications')}
                                className={(activeTab === 'notifications'||activeTab === 'addNotifications') && 'active-tab'}>
                                {isExpanded && <Text>Notifications Templates</Text>}
                            </HStack>
                        </Box>
                    </HStack>
                    <HStack
                        onClick={() => setActiveTab('profile')}
                        className={activeTab === 'profile' && 'active-tab'}>
                        <User/>
                        {isExpanded && <Text>Personal information</Text>}
                    </HStack>
                    <HStack
                        onClick={() => setActiveTab('menuNotif')}
                        className={activeTab === 'menuNotif' && 'active-tab'}>
                        {isExpanded ? <Notification/> : <Message/>}
                        {isExpanded && <Text>Notification</Text>}
                    </HStack>
                </VStack>
                {
                    !isExpanded && (
                        <VStack
                            borderTop={'1px solid'}
                            borderColor={'neutral.800'}
                            p={'16px 10px 0 10px'}
                            mt={'170px'}>
                            <VStack
                                gap={'16px'}
                                p={'16px'}
                                w={'44px'}
                                borderRadius={'8px'}
                                bg={'neutral.1000'}>
                                <Flex
                                    borderRadius={'16px'}
                                    w={'40px'}
                                    h={'40px'}
                                    alignItems={'center'}
                                    justifyContent={'center'}
                                    border={'4px solid'}
                                    bg={'neutral.800'}>
                                    <Notification style={{cursor: 'pointer'}}/>
                                </Flex>
                                <UserShield style={{cursor: 'pointer'}}/>
                                <User style={{cursor: 'pointer'}}/>
                                <Blogger style={{cursor: 'pointer'}}/>
                            </VStack>
                        </VStack>
                    )
                }
            </Box>
            <HStack
                mt={'73px'}
                w={'full'}
                flexDirection={isExpanded ? 'column' : 'row'}
                justifyContent={'center'}>
                {
                    isExpanded ? (
                        <>
                            <Divider borderColor={'neutral.800'}/>
                            <StyledButton
                                mt={'24px'}
                                bg={'neutral.1000'}
                                h={'38px'}
                                w={'full'}
                                color={'neutral.500'}
                                fontSize={'body.sm'}
                                leftIcon={<LogOut/>}>
                                Log Out
                            </StyledButton>
                        </>
                    ) : <LogOut style={{cursor: 'pointer'}}/>
                }
            </HStack>
        </Flex>
    )
}